
export const PRODUCT_FETCH  = 'PRODUCT_FETCH';
export const PRODUCT_UPDATE = 'PRODUCT_UPDATE';
export const PRODUCT_APPEND = 'PRODUCT_APPEND';
export const PRODUCT_SEARCH = 'PRODUCT_SEARCH';